import http from "@/shared/services/http";
import {SiteParams} from "@/modules/sites/params";

export const createSite = (data: any) => http.post(`v1/sites`, data);
export const listSite = (params?: SiteParams) => http.get(`v1/sites`, { params });
// export const allSite = () => http.get(`v1/sites/all`);
export const singleSite = (id: number) => http.get(`v1/sites/${id}`);
export const updateSite = (id: number, data: any) => http.put(`v1/sites/${id}`, data);
export const deleteSite = (id: number) => http.delete(`v1/sites/${id}`);
export const uploadSite = (data) => http.post(`v1/sites/excel`, data);